import { updatePhoneValueForm } from '@sales-center/common'

export const formatInitialPhoneNumberValue = (phoneNumber?: string | null) => {
  if (phoneNumber) {
    let match = phoneNumber.replace(/\D/g, '')
    match = match.length > 10 ? match.slice(-10) : match
    return updatePhoneValueForm(match, false)
  }
  return phoneNumber
}
